<!--
  ApiSidebar — the whole sidebar for API-only tenants (`portal_mode = api`).
  Replaces the cauldron rail and flat menu: no Home, News or cauldrons, only
  the API portal menu from `apiPortalNavigation.js` (which also feeds the
  route guard, so menu and reachable pages stay in step).
-->
<template>
  <nav class="flex h-full flex-col overflow-y-auto px-3 py-3" :aria-label="t('api_store.nav.aria')">
    <div v-if="!collapsed" class="sidebar-section-label">
      {{ t('api_store.nav.section') }}
    </div>
    <sidebar-menu-item
      v-for="item in items"
      :key="item.to"
      :to="item.to"
      :label="t(item.labelKey)"
      :icon="item.icon"
      :collapsed="collapsed"
      :active-match="item.activeMatch"
      @click="emit('navigate')"
    />
  </nav>
</template>

<script setup>
  /* eslint-disable no-undef */
  import SidebarMenuItem from '@/components/navigation/SidebarMenuItem.vue';
  import { apiPortalNavItems } from '@/features/api-store/domain/apiPortalNavigation';
  import { useAuthStore } from '@/stores/useAuthStore';
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  defineProps({
    collapsed: { type: Boolean, default: false },
  });
  const emit = defineEmits(['navigate']);

  const { t } = useI18n();
  const authStore = useAuthStore();

  // Same rule as the members page itself (TenantMembers.vue).
  const isTenantAdmin = computed(
    () => Boolean(authStore.isSuperUser) || (authStore.permissions || []).includes('manage_own_tenant')
  );
  const items = computed(() => apiPortalNavItems({ isTenantAdmin: isTenantAdmin.value }));
</script>
